<div class="col-auto d-flex flex-column align-items-center">
  <div class="logo d-flex flex-row justify-content-center align-items-center">
    <img [src]="family.imageUrl">
  </div>
  <div class="text my-3" [ngClass]="{
    'bosch': family.marque == brand.Bosch,
    'elm': family.marque == brand.Elm
    }">{{family.nom}}
  </div>
</div>